import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { API_ENDPOINTS } from '../config/api.config';
import { Sucursal, SucursalPayload } from '../models/sucursal.model';

@Injectable({
  providedIn: 'root',
})
export class SucursalService {
  private readonly apiUrl = API_ENDPOINTS.sucursales;

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private readonly http: HttpClient) {}

  getByEmpresa(empresaId: number): Observable<Sucursal[]> {
    return this.http
      .get<
        Sucursal[]
      >(`${this.apiUrl}/super-usuario/empresa/${empresaId}/cargar-todos`, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  create(empresaId: number, payload: SucursalPayload): Observable<Sucursal> {
    return this.http
      .post<Sucursal>(
        `${this.apiUrl}/super-usuario/empresa/${empresaId}/crear`,
        payload,
        this.httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  update(
    empresaId: number,
    sucursalId: number,
    payload: Partial<SucursalPayload>,
  ): Observable<Sucursal> {
    return this.http
      .patch<Sucursal>(
        `${this.apiUrl}/super-usuario/empresa/${empresaId}/actualizar/${sucursalId}`,
        payload,
        this.httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  delete(empresaId: number, sucursalId: number): Observable<void> {
    return this.http
      .delete<void>(
        `${this.apiUrl}/super-usuario/empresa/${empresaId}/${sucursalId}`,
        this.httpOptions,
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any): Observable<never> {
    const message =
      error?.error?.message || error?.message || 'Error en gestión de sedes';
    return throwError(() => new Error(message));
  }
}
